// Step03_DOB.js
import React, { useState } from 'react';
import { useForm } from '../context/FormContext';
import { getAge } from '../utils/validation';

export default function Step03_DOB({ onNext, onBack }) {
  const { state, dispatch } = useForm();
  const [err, setErr] = useState('');

  const next = () => {
    if (!state.dateOfBirth) { setErr('Date of birth is required'); return; }
    if (getAge(state.dateOfBirth) < 18) { setErr('Applicant must be at least 18 years old'); return; }
    setErr('');
    onNext();
  };

  return (
    <div className="step-card">
      <h2 className="step-title">Date of Birth</h2>
      <div className="field-group">
        <label className="field-label">Date of Birth <span className="required">*</span></label>
        <input type="date" className={`field-input ${err ? 'error' : ''}`}
          value={state.dateOfBirth}
          max={new Date().toISOString().split('T')[0]}
          onChange={e => { dispatch({ type: 'SET_FIELD', key: 'dateOfBirth', value: e.target.value }); setErr(''); }} />
        {err && <div className="field-error">{err}</div>}
      </div>
      <div className="wizard-nav" style={{ position: 'static', borderTop: 'none', padding: 0, marginTop: 24 }}>
        <button className="btn-back" onClick={onBack}>← Back</button>
        <button className="btn-next" onClick={next}>Next →</button>
      </div>
    </div>
  );
}
